import { Injectable } from '@angular/core';
import { CanActivate, CanDeactivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@node_modules/@angular/router';
import { Observable, map, of } from 'rxjs';
import { AppComponentBase } from '@shared/common/app-component-base';
import { ApplicationService } from '../application/application.service';
import { NiService } from './ni.service';

@Injectable()
export class NiGuard implements CanActivate, CanDeactivate<AppComponentBase> {

    constructor(
        private niService: NiService,
        private applicationService: ApplicationService
    ) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        return this.niService.getNi(this.applicationService.caseId).pipe(map(() => true));
    }

    canDeactivate(component: AppComponentBase): boolean | Observable<boolean> {
        this.niService.closeNi();
        return true;
    }
}
